<template>
    <b-dropdown
        variant="link"
        right
        toggle-class="text-decoration-none"
        no-caret
    >
        <template #button-content>
            <span style="color: black;" class="fas fa-ellipsis-v"></span>
        </template>
        <b-dropdown-item
            @click.prevent="boardingPrint"
            v-if="_hasAccess('schedule.boarding.print.reservation.list')"
            href
        >
            Print Reservation List
        </b-dropdown-item>
        <b-dropdown-item
            @click.prevent="boardingEmail"
            v-if="_hasAccess('schedule.boarding.email.reservation.list')"
            href
        >
            Email Reservation List
        </b-dropdown-item>
        <b-dropdown-item
            @click.prevent="boardingForm"
            v-if="_hasAccess('schedule.boarding.print.boarding.form')"
            href
        >
            Print Boarding Forms
        </b-dropdown-item>
        <boarding-reservation ref="boardingReservationWindow" />
        <boarding-form ref="boardingFormWindow" />
    </b-dropdown>
</template>

<script>
import BoardingReservation from "@/module/schedule/boarding/reservation-list.vue";
import BoardingForm from "@/module/schedule/boarding/print-form.vue";

export default {
    name: "reservationKebab",
    components: {
        BoardingReservation,
        BoardingForm
    },
    methods: {
        boardingEmail() {
            this.$refs["boardingReservationWindow"].open(true);
        },
        boardingPrint() {
            this.$refs["boardingReservationWindow"].open(false);
        },
        boardingForm() {
            this.$refs["boardingFormWindow"].open();
        }
    }
};
</script>
